import React, { useEffect, useRef, useState } from "react";

export default function AutoPostToBank({ payload }) {
    const formRef = useRef(null);
    const [submitting, setSubmitting] = useState(true);

    useEffect(() => {
        if (formRef.current) {
            setTimeout(() => formRef.current.submit(), 0);
        }
    }, []);

    return (
        <div className="flex flex-col items-center justify-center min-h-[200px]">
            {submitting && (
                <div className="flex flex-col items-center space-y-3">
                    <div className="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin" />
                    <p className="text-gray-600 text-sm">Redirecting to bank...</p>
                </div>
            )}

            <form
                method="post"
                //action="https://torus-stage-tebkosova.asseco-see.com.tr/fim/est3Dgate"
                action="https://ecommerce.teb-kos.com/fim/est3Dgate"
                ref={formRef}
                className="hidden"
            >
                {Object.entries(payload.params).map(([name, value]) => (
                    <input key={name} type="hidden" name={name} value={value} readOnly />
                ))}

                <noscript>
                    <button type="submit">Continue</button>
                </noscript>
            </form>
        </div>
    );
}





// import { useEffect, useRef } from "react";
// export default function AutoPostToBank({ payload }) {
//     const formRef = useRef(null);

//     useEffect(() => {
//         formRef.current?.submit();
//     }, []);

//     return (
//         <form method="post" action={"https://torus-stage-tebkosova.asseco-see.com.tr/fim/est3Dgate"} ref={formRef} className="p-4 space-y-3">
//             {Object.entries(payload.params).map(([name, value]) => (
//                 <div key={name} className="flex flex-col">
//                     <span className="text-sm text-gray-600">{name}</span>
//                     <input
//                         type="hidden"
//                         name={name}
//                         value={value}
//                         readOnly
//                         className="border p-2 rounded"
//                     />
//                 </div>
//             ))}

//             <button
//                 type="submit"
//                 className="px-4 py-2 bg-blue-600 text-white rounded"
//             >
//                 Continue
//             </button>

//             <noscript>
//                 <button type="submit">Continue</button>
//             </noscript>
//         </form>
//     );
// }

